import cx from "classnames";
import type { ReactNode } from "react";
import styles from "./PenMenu.module.css";

type SelectableItemProps = {
    isSelected: boolean;
    onClick: () => void;
    className: string;
    selectedClassName: string;
    children: ReactNode;
};

export const SelectableItem = ({
    isSelected,
    onClick,
    className,
    selectedClassName,
    children,
}: SelectableItemProps) => (
    <button
        type="button"
        className={cx(styles.button, className, isSelected && selectedClassName)}
        onClick={onClick}
    >
        {children}
    </button>
);
